module.exports = __webpack_public_path__ + "static/img/iAGV-icon.8fdacd11.png";